let start = 0.42;
export const stepLength = -0.002;

export const steps = [
  {
    text:
      "In 1966, Ed Ruscha drove along the Sunset Strip in West Hollywood, Los Angeles. Using a motorized camera mounted on the back of a pickup truck, he methodically photographed all of the buildings on each side of the street. He assembled the photos in the artists' book Every Building on the Sunset Strip, which challenged how people thought about Los Angeles, art and photography.",
    start: start + stepLength * 0,
    end: start + stepLength * 1,
    mode: "no-map",
    year: "1966"
  },
  {
    text:
      "Ruscha and his collaborators returned again and again to Sunset and various other Los Angeles streets documenting the cityscape for more than fifty-five years. And they continue to record Los Angeles’s thoroughfares today.",
    start: start + stepLength * 1,
    end: start + stepLength * 2,
    mode: "no-years",
    year: "1966"
  },
  {
    text:
      "The resulting archive of Los Angeles evolving through time has remained mostly-unseen for decades; it is so vast that even Ruscha and his team have not seen many of the images. The Getty has digitized more than 60,000 negatives from this collection of more than a half a million total images. You can use the interface here to explore the collection across time and space.",
    start: start + stepLength * 2,
    end: start + stepLength * 3,
    mode: "no-years",
    year: "2007"
  },
  {
    text: "last-step",
    start: start + stepLength * 3,
    end: start + stepLength * 4,
    year: "1985",
    mode: "narrative"
  }
];

export const initialLocation = steps[0].start;
export const endLocation = steps[steps.length - 1].end;
